export default __webpack_public_path__ + "static/media/reply.b345494a.png";